import { PlatformUtility } from 'utility-ts-platform';
import { ContactChannelExplanationService } from '../services/contact_channel_explanation_service';

export class ContactChannelModalController {
  private isMobile: boolean = false;

  constructor(private ngContactChannelExplanationService: ContactChannelExplanationService) {
    this.isMobile = PlatformUtility.isMobile();
  }
}

export class ContactChannelModalComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-notification-settings/src/modals/contact_channel_explanation.html';
  public controller: any = ContactChannelModalController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/modals/contact_channel_explaination.ts